<template>
    <v-container>
      <v-data-table
        :headers="headers"
        :items="tasks"
        item-key="name"
        sort-by="name"
        :search="search"
        class="elevation-1 pt-1"
        mobile-breakpoint="0"
      >
        <template v-slot:top>
          <dialog-create-task dispatcherOnSave= "addTaskMaintenance" :toAddOnSave="{user_created: $store.state.authStore.dataUser['userId'], record_created: null}" :fieldsToAdd="['nextAlert']"></dialog-create-task>
          <v-divider class="mt-1"></v-divider>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Rechercher"
            single-line
            hide-details
            class="ml-4 mr-4"
          ></v-text-field>
        </template>
        <template v-slot:item.checkbox="props">
          <v-dialog
          v-model="dialogCheckbox[props.item.task_id]"
          max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                :color="props.item.is_done ? 'success' : (props.item.is_alert_due ? 'red' : 'blue')"
                v-bind="attrs"
                v-on="props.item.is_done ? '': on"
              >
                <v-icon >
                  mdi-check-circle
                </v-icon>
              </v-btn>
            </template>
            <v-card>
            <v-card-title>
                <span class="text-h5">Notifier tâche effectuée</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogCheckbox[props.item.task_id] = false" >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
              <v-form ref="formAddTaskDone" v-model="isAddTaskDoneFormValid">
              <v-radio-group v-model="props.item.after_task_choice">
                <v-radio
                  :key="props.item.task_id + 'close'"
                  label="Fermer la tâche"
                  value="close"
                ></v-radio>
                <v-radio
                  v-if="!props.item.record_created"
                  :key="props.item.task_id + 'open'"
                  label="Garder la tâche ouverte sans alerte"
                  value="open"
                ></v-radio>

                <!-- Mode date : reprogrammation dans X jours et/ou à une date -->
                <template v-if="!props.item.record_created && (props.item.alert_kind === 'date' || props.item.alert_kind === 'recurring')">
                  <v-radio
                    v-if="props.item.alert_kind === 'recurring'"
                    :key="props.item.task_id + 'reschedDays'"
                    label="Garder ouverte, prochaine alerte dans X jours :"
                    value="reschedDays"
                  ></v-radio>
                  <v-text-field
                    v-if="props.item.alert_kind === 'recurring'"
                    label="Nombre de jours"
                    v-model="props.item.done_recurrence_days"
                    :rules="[v => checkIsStrictlyPositiveOrEmpty(v)]"
                    type="number"
                    min="1"
                    prepend-inner-icon="mdi-calendar-sync"
                    outlined dense hide-details="auto"
                    @click="props.item.after_task_choice = 'reschedDays'"
                  ></v-text-field>
                  <v-radio
                    :key="props.item.task_id + 'reschedDate'"
                    label="Garder ouverte, prochaine alerte le :"
                    value="reschedDate"
                  ></v-radio>
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDate(props.item.done_alert_date)"
                        label="Date de la prochaine alerte"
                        prepend-inner-icon="mdi-calendar"
                        readonly outlined dense hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        @click="props.item.after_task_choice = 'reschedDate'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="props.item.done_alert_date"
                      locale="fr"
                      :first-day-of-week="1"
                      :min="todayISO"
                      @input="props.item.after_task_choice = 'reschedDate'"
                    ></v-date-picker>
                  </v-menu>
                </template>

                <!-- Mode heures d'exploitation -->
                <template v-if="!props.item.record_created && props.item.alert_kind !== 'date' && props.item.alert_kind !== 'recurring' && props.item.last_count_hours">
                  <v-radio
                    :key="props.item.task_id + 'openAlertIn'"
                    label="Garder la tâche ouverte avec rappel dans :"
                    value="openAlertIn"
                  ></v-radio>
                  <v-text-field
                    centered label="Nombre d'heures d'exploitation de l'appareil"
                    v-model="props.item.repetition_default"
                    :rules="[v => checkIsNumber(v)]"
                    prepend-inner-icon="mdi-wrench-clock"
                    outlined
                    dense
                    hide-details="auto"
                    @click="props.item.after_task_choice = 'openAlertIn'"
                  ></v-text-field>
                  <span v-if="props.item.next_alert_exploit_hours_fix">
                    ({{props.item.last_count_hours}}h d'exploitation au {{props.item.date_usage_count_hours}})
                    donc prochaine alerte à {{ props.item.next_alert_exploit_hours_fix }}h
                  </span>
                </template>
                <span v-if="!props.item.record_created && props.item.alert_kind !== 'date' && props.item.alert_kind !== 'recurring' && !props.item.last_count_hours">Pour ajouter une alerte liée au nombre d'heures d'exploitation de l'appareil, il faut avoir au minimum un registre mentionnant son nombre d'heures d'exploitation.</span>
              </v-radio-group>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
              color="blue darken-1"
              text
              @click="closeCheckbox(props.item.task_id)"
              >
              Annuler
              </v-btn>
              <v-btn
              color="blue darken-1"
              text
              :disabled="!isAddTaskDoneFormValid"
              @click="saveCheckbox(props.item)"
              >
              Sauvegarder
              </v-btn>
            </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.infos="props">
          <dialog-infos-task :task="props.item"></dialog-infos-task>
        </template>
        <template v-slot:item.alert_config="props">
          <span v-if="props.item.alert_kind === 'none'" class="grey--text">—</span>
          <div v-else>
            <div v-if="props.item.alert_kind === 'hours'">
              À {{ props.item.next_alert_exploitation_hours }}h d'exploit.
              <span v-if="!isNaN(props.item.next_alert_in_exploit_hours)" class="grey--text">(dans {{ props.item.next_alert_in_exploit_hours }}h)</span>
            </div>
            <div v-else>
              Le {{ formatDate(props.item.next_alert_date) }}
            </div>
            <div v-if="props.item.alert_kind === 'recurring'" class="text-caption grey--text">
              Répétition : tous les {{ props.item.recurrence_interval_days }} jours
            </div>
            <div v-else-if="props.item.alert_kind === 'hours' && props.item.repetition_default != null && props.item.repetition_default !== ''" class="text-caption grey--text">
              Répétition : toutes les {{ props.item.repetition_default }}h
            </div>
          </div>
        </template>
        <template v-slot:item.date_historic="props">
          <v-dialog
          v-model="dialogHistoric[props.item.task_id]"
          max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate" style="max-width: 160px">
                <v-btn
                  icon
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="$store.dispatch('updateListTaskMaintenanceHistory', {task_id: props.item.task_id})"
                >
                  <v-icon >
                    mdi-history
                  </v-icon>
                </v-btn>
                {{ props.item.date_historic }}
              </div>
            </template>
            <v-card>
            <v-card-title>
                <span class="text-h5">Historique de la tâche</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogHistoric[props.item.task_id] = false" >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headersHistoric"
                :items="history"
                class="elevation-1 mt-1"
                mobile-breakpoint="0"
              >
                <template v-slot:item.user="props">
                  {{ props.item.firstname }} {{ props.item.surname }}
                </template>
              </v-data-table>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                color="blue darken-1"
                text
                @click="$set(dialogHistoric, props.item.task_id, false)"
                >
                Fermer
                </v-btn>
            </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.origin="props">
          <span v-if="props.item.record_created">Registre</span>
          <span v-else>Central</span>
        </template>
        <template v-slot:item.actionsTask="props">
          <v-btn
          icon>
            <v-icon
            color="red"
            large
            @click="$store.dispatch('deleteTaskMaintenance', {task_id: props.item.task_id, lift_id: props.item.lift_id})">
              mdi-delete-circle
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
</template>

<script>
import DialogCreateTask from '@/components/DialogCreateTask'
import DialogInfosTask from '@/components/DialogInfosTask'
  export default {
    name: "TasksMaintenanceLift",
    components: {
      DialogCreateTask,
      DialogInfosTask
    },
    data () {
      return {
        search:'',
        headersHistoric: [
          {text: 'Date', value: 'datetime_done'},
          {text: 'Responsable', value: 'user'},
        ],
        dialogCreationTask: false,
        dialogCheckbox: {},
        dialogDescription: {},
        dialogHistoric: {},
        isAddTaskFormValid: false,
        isAddTaskDoneFormValid: false,
        taskName: null,
        nextAlert: null,
        taskDescription: null,
      }
    },
    computed: {
      headers(){
        let headers = [
          {text: 'Effectuée ?', value: 'checkbox'},
          {text: 'Appareil', value: 'lift_name'},
          {text: 'Tâche', value: 'title', cellClass: 'pr-0', class: 'pr-0'},
          {text: '', value: 'infos', cellClass: 'px-0', class: 'px-0', sortable: false},
          {text: 'Origine', align: 'center', value: 'origin'},
          {text: 'Date ajout', align: 'center', value: 'time_creation'},
          {text: 'Alerte', value: 'alert_config', sortable: false},
          {text: 'Historique', value: 'date_historic'},
        ]
        if(this.$store.state.authStore.isResponsableRM){
          headers.push({ text: "Modifier tâche", value: 'actionsTask', sortable: false })
        }
        return headers
      },
      liftId(){
        return this.$store.state.liftsStore.selectedLiftCentral.lift_id
      },
      todayISO(){
        return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      },
      tasks(){
        let today = this.todayISO
        let tasks = this.$store.state.liftsStore.listTasksMaintenance
        tasks.forEach(el => {
          // Type d'alerte déduit des champs renseignés (un seul mode à la fois)
          if(el.recurrence_interval_days != null) el.alert_kind = 'recurring'
          else if(el.next_alert_date) el.alert_kind = 'date'
          else if(el.next_alert_exploitation_hours != null) el.alert_kind = 'hours'
          else el.alert_kind = 'none'
          el.next_alert_exploit_hours_fix = el.repetition_default != null ? Number(el.last_count_hours) + Number(el.repetition_default) : null
          el.next_alert_in_exploit_hours = Number(el.next_alert_exploitation_hours) - Number(el.last_count_hours)
          // Choix par défaut dans le menu "tâche effectuée" selon le type d'alerte
          if(el.alert_kind === 'recurring') el.after_task_choice = 'reschedDays'
          else if(el.alert_kind === 'hours' && el.repetition_default != null && el.repetition_default !== '') el.after_task_choice = 'openAlertIn'
          else el.after_task_choice = 'close'
          // Valeurs pré-remplies pour le menu (reprogrammation par date)
          if(el.done_recurrence_days === undefined) el.done_recurrence_days = el.recurrence_interval_days
          if(el.done_alert_date === undefined) el.done_alert_date = null
          // L'alerte est-elle déjà due ? (pour la couleur du bouton)
          if(el.alert_kind === 'hours') el.is_alert_due = el.next_alert_exploitation_hours != null && el.next_alert_in_exploit_hours <= 0
          else if(el.alert_kind === 'date' || el.alert_kind === 'recurring') el.is_alert_due = !!el.next_alert_date && String(el.next_alert_date).substr(0,10) <= today
          else el.is_alert_due = false
          el.time_creation = new Date(el.time_creation).toLocaleString('fr-FR')
        })
        return tasks
      },
      history(){
        let history = this.$store.state.liftsStore.listTaskMaintenanceHistory
        history.forEach(el => el['datetime_done'] = new Date(el['datetime_done']).toLocaleString('fr-FR'))
        return history
      }
    },
    methods: {
        closeCheckbox(itemId) {
          this.$set(this.dialogCheckbox, itemId, false)
        },
        async saveCheckbox(item) {
            let payload = {
              task_id: item.task_id,
              user_closed: this.$store.state.authStore.dataUser['userId'],
              close_task: item.after_task_choice == 'close',
              next_alert_date: null,
              next_alert_exploitation_hours: null,
            }
            if(item.after_task_choice === 'openAlertIn'){
              payload.next_alert_exploitation_hours = item.next_alert_exploit_hours_fix
            } else if(item.after_task_choice === 'reschedDays'){
              payload.next_alert_date = this.addDaysISO(item.done_recurrence_days)
            } else if(item.after_task_choice === 'reschedDate'){
              payload.next_alert_date = item.done_alert_date
            }
            // 'close' et 'open' laissent les deux seuils à null
            await this.$store.dispatch('addDoneTaskMaintenance', payload).then(() => {
                this.closeCheckbox(item.task_id)
            })
        },
        formatDate(iso){
          if(!iso) return ''
          const [year, month, day] = String(iso).substr(0, 10).split('-')
          return day + '/' + month + '/' + year
        },
        addDaysISO(nbDays){
          let d = new Date()
          d.setDate(d.getDate() + Number(nbDays))
          return (new Date(d.getTime() - d.getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        },
        checkIsNumber(value, errorMessage) {
          if (errorMessage == null) {
            errorMessage = 'La valeur doit être un nombre. Ex: 15'
          }
          return (value >= 0) || (value == null) || errorMessage
        },
        checkIsStrictlyPositiveOrEmpty(value, errorMessage) {
          if (errorMessage == null) {
            errorMessage = 'Le nombre de jours doit être un entier positif. Ex: 30'
          }
          return (value == null) || (value === '') || (Number.isInteger(Number(value)) && Number(value) > 0) || errorMessage
        },
    },
    mounted(){
      this.$store.dispatch('updateListTasksMaintenance')
    }
  }
</script>